import React from 'react'

export default ({ title, date, children }) => {
  return (
    <article className="mt-8">
      <strong>{date}</strong>
      <div className="ml-2 border-l-4 pl-4 border-theme">
        <h4 className="text-lg">{title}</h4>
        <div className="-mt-4">{children}</div>
      </div>
    </article>
  )
}
